import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia, Button } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, Print } from "@mui/icons-material";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchSales, apiURL } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  getFromToDate4AcYear,
  validatedate_min_max,
  setDateChange,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import SalesInvoiceSelection from "./SalesInvoiceSelection";
import CustomerDateWiseSales from "./CustomerDateWiseSales";
import ResetDate from "../images/resetdate.png";
import { json } from "react-router-dom";

class ProformaList extends Component {
  state = {
    Company: [],
    Customer: [],
    TransationType: [],
    PaymentMode: [],
    ShipTo: [],
    ListType: [
      { Type: "Pending Invoice" },
      { Type: "All" },
      { Type: "Paid Invoice" },
    ],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "dat_salesdateDMY", label: "Date" },
      { id: "vac_billtype", label: "Proforma Type" },
      { id: "vac_billno", label: "Proforma No" },
      { id: "vac_customer", label: "Customer" },
      { id: "vac_customershipto", label: "Ship To" },
      { id: "dec_discamt", label: "Discount Amt" },
      { id: "dec_taxable", label: "Taxable" },
      { id: "dec_cgst", label: "CGST", hide: true },
      { id: "dec_sgst", label: "SGST", hide: true },
      { id: "dec_igst", label: "IGST", hide: true },
      { id: "cs", label: "CS" },
      { id: "i", label: "I" },
      { id: "dec_grtotal", label: "Grand Total" },
      { id: "dec_tdsamount", label: "TDS Amount" },
      { id: "dec_advancepayment", label: "Adv.Payment" },
      { id: "dec_netpayment", label: "Net Payment" },
      { id: "vac_salestransactiontype", label: "Transaction Type" },
      { id: "vac_remark", label: "vac_remark", hide: true },
      { id: "bint_acid", label: "bint_acid", hide: true },
      { id: "vac_company", label: "vac_company", hide: true },
      { id: "bint_salessrno", label: "bint_salessrno", hide: true },
      { id: "bint_billno", label: "bint_billno", hide: true },
      { id: "bint_vouno", label: "bint_vouno", hide: true },
      { id: "dat_salesdate", label: "Date", hide: true },
      { id: "itemlist", label: "Item List" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "ProformaList:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "ProformaList:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Sales == "R" ||
          this.props.userPrivilege.Sales == "W",
      },
      {
        name: "Print Invoice",
        icon: <Print />,
        link: "ProformaList:",
        actionType: "AlertResponsive",
        hide: this.props.userPrivilege.Sales == "R",
      },
    ],
    searchData: {},
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    keyColumn: [],
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : " + this.props.module + " List";
    this.props.setActiveMenu(this.props.module + "List");
    this.setSearchColumns();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "dtpFromDate" || e.target.name === "dtpToDate") {
          this.setfrom_todate();
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  navigateSalesEntry = (bint_acid, bint_salessrno, bint_acyear) => {
    this.props.navigateTo(this.props.entryPage, {
      bint_acid: bint_acid,
      bint_salessrno: bint_salessrno,
      bint_acyear: bint_acyear,
    });
  };

  handleARDonActionClick = (row) => {};

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {};

  handleOnCusDateWiseSalesClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // alertTitle={'Sales Item Entry'}
          alertMessage={<CustomerDateWiseSales />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };
  //#endregion handle

  //region function
  handleOnNewEntryClick = () => {
    this.props.navigateTo(this.props.entryPage);
  };

  setSearchColumns = () => {};

  validateProforma = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;

    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter FromDate", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter ToDate", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    if (this.validateProforma()) {
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SalesList",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
        };
        fetchSales(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let rows = res.data.SalesList,
              rowsCount = rows.length;

            this.setState({
              dataLoadStatus,
              rows,
              rowsCount,
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getInfo.", error);
          });
      });
      document.getElementById("dtpFromDate").focus();
    }
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "Sales",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      window.location.reload();
      this.onFormLoad();
    }
  };

  onFormLoad = () => {
    const { fromdate, todate } = getlocalstoragedate("Sales");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        this.getInfo();
      }
    );
  };

  deleteProformaList = (bint_acid, bint_salessrno, bint_acyear) => {};

  //#endregion handle

  //#endregion handle

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
        ? this.state.searchRowsCount
        : this.state.rowsCount,
      { module } = this.props;
    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>{module + " List"}</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID={"dtpToDate"}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.getInfo}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>

              <Grid item>
                <CtBtn id="btnLoad" label="Load" onClick={this.getInfo} />
              </Grid>

              {/* <Grid item>
                <CtBtn
                  label="To Date"
                  onClick={this.handleOnCusDateWiseSalesClick}
                />
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          toolTipNewEntry="Sales Entry"
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(ProformaList))));
